import { combineReducers } from 'redux'

import agencyCaseManagement from 'src/store/modules/admin/agencyCaseManagement'
import caregiverManagement from 'src/store/modules/admin/caregiverManagement'
import caseManagers from 'src/store/modules/admin/caseManagers'
import clinicians from 'src/store/modules/admin/clinicians'
import facilityManagement from 'src/store/modules/admin/facilityManagement'
import medicalDeviceOrdering from 'src/store/modules/admin/medicalDeviceOrdering'
import providerManagement from 'src/store/modules/admin/providerManagement'
import providerPortal from 'src/store/modules/admin/providerPortal'
import quickMessagesManagement from 'src/store/modules/admin/quickMessagesManagement'
import referralPayer from 'src/store/modules/admin/referralPayer'
import referralSource from 'src/store/modules/admin/referralSource'
import ribbonManagement from 'src/store/modules/admin/ribbonManagement'
import userSearch from 'src/store/modules/admin/userSearch'

export default combineReducers({
  agencyCaseManagement,
  caregiverManagement,
  caseManagers,
  clinicians,
  facilityManagement,
  medicalDeviceOrdering,
  providerManagement,
  providerPortal,
  quickMessagesManagement,
  referralPayer,
  referralSource,
  ribbonManagement,
  userSearch
})

export * from 'src/store/modules/admin/agencyCaseManagement'
export * from 'src/store/modules/admin/caregiverManagement'
export * from 'src/store/modules/admin/caseManagers'
export * from 'src/store/modules/admin/clinicians'
export * from 'src/store/modules/admin/facilityManagement'
export * from 'src/store/modules/admin/medicalDeviceOrdering'
export * from 'src/store/modules/admin/providerManagement'
export * from 'src/store/modules/admin/providerPortal'
export * from 'src/store/modules/admin/quickMessagesManagement'
export * from 'src/store/modules/admin/referralPayer'
export * from 'src/store/modules/admin/referralSource'
export * from 'src/store/modules/admin/ribbonManagement'
export * from 'src/store/modules/admin/userSearch'
